import { Button } from "@mantine/core";
import { Link, useParams } from "@tanstack/react-router";

import { StatusScreen } from "../../ui/StatusScreen";

/**
 * A Pro address with no page (`pro/<anything>`), drawn inside Pro's own frame in Classic's words
 * (`platform/screens.tsx`, `NotFoundScreen`); its way back is Pro's Home for the brand, so the
 * person stays in Pro (spec ui-perf/pro-fixes-notfound-case).
 */
export function ProNotFound() {
  const { teamId, brandId } = useParams({ from: "/signed-in/teams/$teamId/brands/$brandId/studio/pro" });
  return (
    <StatusScreen
      title="Page not found"
      message="This page does not exist, or it belongs to a team you are not a member of."
      action={
        <Button
          variant="light"
          renderRoot={(props) => (
            <Link {...props} to="/teams/$teamId/brands/$brandId/pro" params={{ teamId, brandId }} />
          )}
        >
          Go to your team
        </Button>
      }
    />
  );
}
